// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__ptX03","header":"MessagesList_header__2t-kp","chat":"MessagesList_chat__2fyVq"};